import { TaxcardRoutes } from '@/app/api-routes';
import { get, post } from '@/app/core/request';

class PrintingApi {
  async setTaxcardsPrinted(taxcardIds: number[], customerUUID: String) {
    return post<Boolean>(TaxcardRoutes.setPrinted, {
      taxcardIds,
      customerUUID,
    });
  }
  async preparePrint(transactionId: string, taxcardIds: number[], customerUUID: string): Promise<{ printId: string }> {
    const ID_SEPARATOR = ',';
    return get<{ printId: string }>(
      TaxcardRoutes.getPreparePrintId(transactionId, taxcardIds.join(ID_SEPARATOR), customerUUID)
    );
  }
  getPDFDownLoadLink(printId: string, fileName: string): string {
    return TaxcardRoutes.getPrintPDF(printId, fileName);
  }
  async shareWithMail(taxcardIds: string[], mail: String) {
    return post<void>(TaxcardRoutes.sendShareMail, {
      ids: taxcardIds,
      mail,
    });
  }
}

export default new PrintingApi();
